import React, {useState} from "react";
import {Button, translate,} from "react-admin";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import CancelIcon from "@material-ui/icons/Cancel";
import Swal from "sweetalert2";
import axiosInstance from "../../api/axios";
import env from "../../env";
import {showErrorNotify, showSuccessNotify} from "../../components";
import {CircularProgress} from "@material-ui/core";

const ShowFooterActions = ({record}) => {
    const [loading, setLoading] = useState(false);

    if (!record) return null;

    const isInReview = record.status === "IN_REVIEW";
    const haveRefund = record.purchaseCount > 0;
    const confirmAccept = () => {
        Swal.fire({
            title: "Bạn chắc chắn muốn duyệt yêu cầu huỷ?",
            text: "Các đơn đăng ký sẽ được huỷ và hoàn tiền cho người mua. Thao tác này sẽ không được khôi phục.",
            type: 'warning',
            showCloseButton: true,
            showCancelButton: true,
            cancelButtonColor: '#d33',
            focusConfirm: false,
        })
            .then((result) => {
                if (result.value) {
                    setLoading(true)
                    axiosInstance.put(`/api/purchaseCancelRequestAuthorizes/accept/${record.id}`, {}, {
                        newBaseUrl: env.kiotUrl,
                    }).then((res) => {
                        setLoading(false)
                        if (res?.data?.success) {
                            showSuccessNotify("Duyệt huỷ đơn đặt hàng thành công")
                            window.location.href = "#/purchaseCancelRequestAuthorizes";
                        } else {
                            showErrorNotify("Duyệt huỷ đơn đặt hàng không thành công")
                        }
                    }).catch(err => {
                        setLoading(false)
                        showErrorNotify(err.message)
                    })
                }
            });
    }
    const confirmReject = () => {
        Swal.fire({
            title: "Bạn chắc chắn muốn từ chối yêu cầu huỷ?",
            text: "",
            type: 'warning',
            showCloseButton: true,
            showCancelButton: true,
            cancelButtonColor: '#d33',
            focusConfirm: false,
        })
            .then((result) => {
                if (result.value) {
                    setLoading(true)
                    axiosInstance.put(`/api/purchaseCancelRequestAuthorizes/reject/${record.id}`, {}, {
                        newBaseUrl: env.kiotUrl,
                    }).then((res) => {
                        setLoading(false)
                        if (res?.data?.success) {
                            showSuccessNotify("Từ chối huỷ đơn đặt hàng thành công")
                            window.location.href = "#/purchaseCancelRequestAuthorizes";
                        } else {
                            showErrorNotify("Từ chối huỷ đơn đặt hàng không thành công")
                        }
                    }).catch(err => {
                        setLoading(false)
                        showErrorNotify(err.message)
                    })
                }
            });
    }
    return (
        <div style={{marginTop: 24, display: "flex", gap: 12}}>
            <Button
                label="Quay lại"
                onClick={() => window.history.back()}
                disabled={loading}
            >
                <ArrowBackIcon/>
            </Button>

            {isInReview && haveRefund && (
                <Button
                    label="Chấp nhận"
                    style={{color: "#37662d"}}
                    onClick={confirmAccept}
                    disabled={loading}
                >
                    <CheckCircleIcon/>
                </Button>
            )}
            {isInReview && (
                <Button
                    label="Từ chối"
                    style={{color: "#d32f2f"}}
                    onClick={confirmReject}
                    disabled={loading}
                >
                    <CancelIcon/>
                </Button>
            )}
            {loading && <CircularProgress style={{marginLeft: 10}} color="secondary"/>}
        </div>
    );
};

export default translate(ShowFooterActions);
